import { render, staticRenderFns } from "./m-product-stock-alert.vue?vue&type=template&id=98de2cbc&"
import script from "./m-product-stock-alert.vue?vue&type=script&lang=js&"
export * from "./m-product-stock-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports